import AxiosInstance from '../AxiosInstance/AxiosInstance';
import CustomIndexedDB from '../IndexedDB/IndexedDB';

const Logout = { 

  helper: function () {
    AxiosInstance({
      method: "post",
      url: "Token/RevokeToken",
      data: {
        accessToken: sessionStorage.getItem("NewQRadar_accessToken"),
        refreshToken: sessionStorage.getItem("NewQRadar_refreshToken")
      }
    }).then(response => {
      //sessionStorage.removeItem("NewQRadar_accessToken");
      //sessionStorage.removeItem("NewQRadar_refreshToken");
      //sessionStorage.removeItem("NewQRadar_tbBCMmDepartmentID");
      //sessionStorage.removeItem("NewQRadar_tbWFLtBCMTransactionID");
      //sessionStorage.removeItem("NewQRadar_BCMDisableDepartment");
      //sessionStorage.removeItem("NewQRadar_scoreCard");
      //sessionStorage.removeItem("NewQRadar_userName");
      //sessionStorage.removeItem("sub_Menu");
      sessionStorage.clear();
      CustomIndexedDB.delete()
      window.location.hash = process.env.PUBLIC_URL + "#/login"; 
    }).catch(error => {
      window.location.hash = process.env.PUBLIC_URL + "#/login";
    });
  },
  logoutHelper:function(){
    //sessionStorage.removeItem("NewQRadar_accessToken");
    //sessionStorage.removeItem("NewQRadar_refreshToken");
    //sessionStorage.removeItem("NewQRadar_tbBCMmDepartmentID");
    //sessionStorage.removeItem("NewQRadar_tbWFLtBCMTransactionID");
    //sessionStorage.removeItem("NewQRadar_BCMDisableDepartment");
    //sessionStorage.removeItem("sub_Menu");
    sessionStorage.clear();
    CustomIndexedDB.delete()
    window.location.hash = process.env.PUBLIC_URL + "#/login";
  }
}

export default Logout;

